/**
 * 车机端 Cloud App JS Bridge
 * https://nio.feishu.cn/docx/C9jBdGw0aokS83xPWpdcZLABn4e
 */

export default class NioCloudAppJsBridge {

    static _eventCallBackListenerList = [];

    static _eventCallBack(eventKey, value) {

        this._eventCallBackListenerList.forEach((handler) => {
            try {
                handler(eventKey, value);
            } catch (e) {
                console.error('window.nio_cloud_app.EventCallBack failed.\n', e);
            }
        });
    }

    /**
     * 初始化 EventCallBack 方法供车机端调用
     */
    static initEventCallBack() {
        if (!window.nio_cloud_app) {
            window.nio_cloud_app = {};
        }
        window.nio_cloud_app.EventCallBack = (eventKey, value) => {
            this._eventCallBack(eventKey, value);
        };
    }

    /**
     * H5调用-InvokeEvent
     * 车机端实现，供H5通知车机端需要处理的事件
     * @param {string} eventKey
     * @param {string} value
     * @return string JSON string
     */
    static invokeEvent(eventKey, value = '') {
        try {
            let _value = value;
            if (typeof value !== 'string') {
                _value = JSON.stringify(value);
            }
            const resString = window.nio_cloud_app.InvokeEvent(
                eventKey,
                _value,
                null,
            );
            return JSON.parse(resString || '{}');
        } catch (e) {
            console.error(e);
            return {
                result: -1,
                jsException: e,
            };
        }
    }

    static getLoginInfo() {
        return this.invokeEvent('1001');
    }
}
